import { Pipe, PipeTransform } from '@angular/core';
import { AppMenuPoint } from '@agilox/common';

@Pipe({
	name: 'appBackground',
})
export class AppBackgroundPipe implements PipeTransform {
	transform(
		app: AppMenuPoint,
		hoveredApp: AppMenuPoint | undefined,
		activeApp: AppMenuPoint | undefined
	): string {
		if (hoveredApp === app) {
			return app.color?.backgroundHover ?? '';
		}

		if (activeApp?.name === app.name) {
			return app.color?.background ?? '';
		}
		return '';
	}
}
